module.exports = __webpack_public_path__ + "static/media/404.9ed13bbe.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/404.svg
// module id = 543
// module chunks = 20